import React from "react";
import { EntryKind } from "../../model/entry/types/EntryKind.enum";
import { Tooltip } from "../../utils/local-antd";
import { Flex } from "../Flex";
import { useTranslation } from "react-i18next";
import { Button } from "../Button";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons/faWhatsapp";
import { TextWithTruncated } from "../TextWithTruncated";
import { CopyButton } from "../CopyButton";
import styled from "styled-components";
import { Rounded } from "../../theme/Rounded";
import { Spacing } from "../../theme/Spacing";
import { getWhatsappUrl } from "../../utils/String";

const Container = styled(Flex)`
  align-items: center;
  justify-content: space-between;
  gap: ${Spacing.s};
  padding: ${Spacing.xs};
  border-radius: ${Rounded.md};
  background-color: ${({ theme }) => theme.whatsapp};
`;

const StyledCopyButton = styled(CopyButton)`
  margin: 0 !important;
  padding: 0 !important;
  background-color: ${({ theme }) => theme.white};
  border-radius: ${Rounded.circle};
  height: 2rem;
  width: 2rem;

  svg {
    color: ${({ theme }) => theme.whatsapp};
  }

  &:hover {
    background-color: ${({ theme }) => theme.white};
  }
`;

const StyledButton = styled(Button)`
  padding: 0;
  margin: 0;
  background-color: ${({ theme }) => theme.white};
  border-radius: ${Rounded.circle};
  height: 2rem;
  width: 2rem;
  color: ${({ theme }) => theme.whatsapp};
`;

const StyledTextWithTruncated = styled(TextWithTruncated)`
  direction: ltr;
  color: ${({ theme }) => theme.white} !important;
`;

// Lets the number shrink (and be cut with an ellipsis) when the cell is
// narrower than it, rather than cutting it after a fixed number of characters
const PhoneDetails = styled(Flex)`
  flex: 1;
  min-width: 0;
`;

type Props = {
  phone?: string;
  extra?: {
    kind?: EntryKind;
  };
};

export const TableActionableCellPhone: React.FC<Props> = ({ phone, extra }) => {
  const { t } = useTranslation();

  const onClick = () => {
    if (phone) {
      window.open(getWhatsappUrl(phone), "_blank");
    }
  };

  if (!phone?.length) {
    return null;
  }

  return (
    <Container className="actionable-cell">
      <PhoneDetails gap="s" alignItems="center">
        <Tooltip title={t("entries.table.settings.columns.whatsapp.title")}>
          <StyledButton onClick={onClick} icon={faWhatsapp} iconWidth="xl" />
        </Tooltip>

        <StyledTextWithTruncated fitToWidth direction="ltr">
          {phone}
        </StyledTextWithTruncated>
      </PhoneDetails>

      <StyledCopyButton copy={phone} iconSize="lg" />
    </Container>
  );
};
